<app-navbar></app-navbar>

<div class="commande-form">

  <a routerLink="/lots">
    <button>
      <mat-icon>arrow_back</mat-icon>
      Retour aux lots
    </button>
  </a>

  <h2>Nouvelle Commande</h2>

  <form>

    <div class="form-group">
      <label for="nomCommande">Nom de votre commande</label>
      <input id="nomCommande" type="text" placeholder="Nom du lot" class="form-control">
    </div>

    <div class="form-group">
      <label for="fichierExcel">Fichier Excel (PNGC)</label>
      <input id="fichierExcel" type="file" class="form-control">
    </div>

    <div class="form-group">
      <label for="delai">Délai de traitement souhaité</label>
      <select id="delai" class="form-control">
        <option value="1j">Le plus rapide possible</option>
        <option value="1s">Sous 1 semaine</option>
        <option value="2s">Sous 2 semaines</option>
        <option value="4s">Sous 4 semaines</option>
        <option value="4s">Pas de délai en particulier</option>
      </select>
    </div>

    <div class="form-group checkbox-group">
      <label>
        <input type="checkbox">
        Contrôle par acheminement exigé ?
      </label>
    </div>

    <div class="form-group">
      <label for="commentaires">Commentaires</label>
      <textarea id="commentaires" rows="3" placeholder="Zone texte libre..." class="form-control"></textarea>
    </div>

    <button  class="submit-btn">Envoyer</button>

  </form>
</div>
